exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:600px){.container-fluid[data-v-02538671]{width:75%;font-size:14px}}@media (min-width:1200px){.container-fluid[data-v-02538671]{width:75%;font-size:10px}}@media (min-width:2050px){.container-fluid[data-v-02538671]{width:75%;font-size:14px}}.centered-and-cropped[data-v-02538671]{object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02538671","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/windows/WindowEdit.vue
// module id = 131
// module chunks = 0